import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import LockResetIcon from "@mui/icons-material/LockReset";
import { faBan, faPen, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Divider from "@mui/material/Divider";
import {
  Tooltip,
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { policies as permessi } from "../../const/policies";
import useMobileDetection from "../../Hooks/useMobileDetection";
import { handleDialogToEditUser } from "./operations/handleDialogToEditUser";
import { setScrollY } from "../../redux/reducers/scroll-reducer";
import { style } from "@mui/system";

const ButtonBoxUsers = ({ row: rowInfo }) => {
  const state = useSelector((state) => state.userDate);
  const viewState = useSelector((state) => state.viewState);
  const { policies } = state;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useMobileDetection(600);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    setScrollY(document.querySelector("main.MuiBox-root").scrollTop);
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };
  const handleAction = (dialogType) => (event) => {
    dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));
    handleDialogToEditUser({ dialogType, rowInfo }, dispatch, event);
    handleMenuClose();
  };

  if (isMobile || viewState) {
    return (
      <>
        {policies.indexOf(permessi.utentiCancellazione) !== -1 && (
          <Box
            onClick={handleAction("delete")}
            sx={actionButtonStyle}
          >
            {!rowInfo.dataDel ? (
              <FontAwesomeIcon icon={faBan} size="xs" style={{ color: "#636161" }} />
            ) : (
              <LoopOutlinedIcon sx={{ fontSize: 14, color: "#636161" }} />
            )}
            <Typography sx={{ fontSize: 10, color: "#636161" }}>
              {!rowInfo.dataDel ? t("disable_Action") : t("enable")}
            </Typography>
          </Box>
        )}

        {policies.indexOf(permessi.utentiResetPassword) !== -1 &&
          rowInfo.hasPassword && (
            <Box
              onClick={handleAction("reset")}
              sx={actionButtonStyle}
            >
              <LockResetIcon sx={{ fontSize: 14, color: "#636161" }} />
              <Typography sx={{ fontSize: 10, color: "#636161" }}>
                {t("res_psw_v2")}
              </Typography>
            </Box>
          )}
      </>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title={t("actions")}>
          <IconButton
            onClick={handleMenuClick}
            size="small"
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
            }}
          >
            <FontAwesomeIcon icon={faEllipsisV} size="lg" />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {policies.indexOf(permessi.utentiInserimentoModifica) !== -1 && (
          <>
            <MenuItem onClick={handleAction("edit")}>
              <ListItemIcon>
                <FontAwesomeIcon icon={faPen} />
              </ListItemIcon>
              <ListItemText>{t("edit")}</ListItemText>
            </MenuItem>

            {!isMobile && <Divider />}
          </>
        )}

        {policies.indexOf(permessi.utentiCancellazione) !== -1 && (
          <>
            <MenuItem onClick={handleAction("delete")}>
              <ListItemIcon>
                {!rowInfo.dataDel ? (
                  <FontAwesomeIcon icon={faBan} />
                ) : (
                  <LoopOutlinedIcon />
                )}
              </ListItemIcon>
              <ListItemText>
                {!rowInfo.dataDel ? t("disable_Action") : t("enable")}
              </ListItemText>
            </MenuItem>

          </>
        )}

        {policies.indexOf(permessi.utentiResetPassword) !== -1 &&
          rowInfo.hasPassword && (
            <MenuItem onClick={handleAction("reset")}>
              <ListItemIcon>
                <LockResetIcon />
              </ListItemIcon>
              <ListItemText>{t("res_psw_v2")}</ListItemText>
            </MenuItem>
          )}
      </Menu>
    </>
  );
};

export default ButtonBoxUsers;